import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { Capability } from '__types__';
import { useRestrictedAccess } from 'lib/restrictedAccess';
import { deleteResourceSlotAssignment } from 'store/v1/productions/productions.actions.js';
import { openModal } from 'store/v1/ui/ui.actions.js';

import { BookingConfirmationMenuItem } from 'v1/components/shared';
import { Button } from 'v5/design-system/Button';
import { MoreHorizontal, Trash2 } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from 'v5/design-system/DropdownMenu';

const ResourceSlotAssignmentOptions = ({ productionId, assignment }) => {
  const dispatch = useDispatch();

  const showMenu = useRestrictedAccess(null, null, [
    Capability.PRODUCTION_READ,
    Capability.PRODUCTION_UPDATE
  ]);

  const showRemove = useRestrictedAccess(null, null, [
    Capability.PRODUCTION_UPDATE
  ]);

  // Note: SEND_BOOKING_CONFIRMATION toast listener removed to prevent duplicates.
  // BookingConfirmationMenuItem (via BookingActions) handles this using the centralized helper.

  if (!showMenu) {
    return null;
  }

  const onResourceSlotAssignmentRemove = () => {
    dispatch(
      openModal('ConfirmModal', {
        title: 'Are you sure you want to remove this assignment?',
        confirmLabel: 'Confirm delete',
        onConfirm: () =>
          dispatch(
            deleteResourceSlotAssignment({
              production_id: productionId,
              resource_slot_id: assignment.resource_slot_id,
              resource_slot_assignment_id: assignment.id
            })
          )
      })
    );
  };

  return (
    <div className="tailwind-root contents">
      <DropdownMenu>
        <DropdownMenuTrigger>
          <Button variant="ghost" size="sm" layout="icon">
            <MoreHorizontal />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <BookingConfirmationMenuItem bookingId={assignment.booking_id} />
          {showRemove && (
            <DropdownMenuItem
              onSelect={() => onResourceSlotAssignmentRemove(assignment.id)}
            >
              <Trash2 className="text-fg-danger" />
              Remove resource
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

ResourceSlotAssignmentOptions.propTypes = {
  productionId: PropTypes.number,
  assignment: PropTypes.object
};

export default ResourceSlotAssignmentOptions;
